export const TOPICS_WIDGET_DATA_KEY = 'TOPICS_DATA';

export const KEYWORDS_CLOUD_DATA_KEY = 'KEYWORDS_CLOUD_DATA';

export const CONVERSATION_CLUSTER_DATA_KEY = 'CONVERSATION_CLUSTER_DATA';

export const IMPACT_SCORE_WIDGET_DATA_KEY = 'IMPACT_SCORE_DATA';

export const TOPICS_WIDGET_PREVIOUS_DATA_KEY = 'TOPICS_PREVIOUS_DATA';

export const TRENDING_KEYWORDS_WIDGET_DATA_KEY = 'TRENDING_KEYWORDS_DATA';

export const TRENDING_LABELS_WIDGET_DATA_KEY = 'TRENDING_LABELS_DATA';

export const IMPACT_SCORE_WIDGET_PREVIOUS_DATA_KEY = 'IMPACT_SCORE_PREVIOUS_DATA';

export const TRENDING_KEYWORDS_WIDGET_PREVIOUS_DATA_KEY = 'TRENDING_KEYWORDS_PREVIOUS_DATA';

export const TRENDING_LABELS_WIDGET_PREVIOUS_DATA_KEY = 'TRENDING_LABELS_PREVIOUS_DATA';

export const IMPACT_SCORE_WIDGET_CHART_DATA_KEY = 'IMPACT_SCORE_CHART_DATA';

export const SENTIMENT_WIDGET_CHART_DATA_KEY = 'SENTIMENT_WIDGET_CHART_DATA';

export const SENTIMENT_WIDGET_CHARTS_DATA_KEY = 'SENTIMENT_WIDGET_CHARTS_DATA';

export const SENTIMENT_WIDGET_COUNTERS_DATA_KEY = 'SENTIMENT_WIDGET_COUNTERS_DATA_KEY';

export const REVIEWS_WIDGET_DATA_KEY = 'REVIEWS_WIDGET_DATA';

export const REVIEWS_WIDGET_PREVIOUS_DATA_KEY = 'REVIEWS_WIDGET_PREVIOUS_DATA';

export const DEMOGRAPHICS_WIDGET_LANGUAGES_DATA_KEY = 'DEMOGRAPHICS_LANGUAGES_DATA';

export const DEMOGRAPHICS_WIDGET_COUNTRIES_DATA_KEY = 'DEMOGRAPHICS_COUNTRIES_DATA';

export const NETWORK_BREAKDOWN_WIDGET_CHART_DATA_KEY = 'NETWORK_BREAKDOWN_WIDGET_CHART_DATA_KEY';

export const ALL_KEYS = [
    CONVERSATION_CLUSTER_DATA_KEY,
    TOPICS_WIDGET_DATA_KEY,
    KEYWORDS_CLOUD_DATA_KEY,
    REVIEWS_WIDGET_DATA_KEY,
    IMPACT_SCORE_WIDGET_DATA_KEY,
    TOPICS_WIDGET_PREVIOUS_DATA_KEY,
    SENTIMENT_WIDGET_CHART_DATA_KEY,
    REVIEWS_WIDGET_PREVIOUS_DATA_KEY,
    SENTIMENT_WIDGET_CHARTS_DATA_KEY,
    SENTIMENT_WIDGET_COUNTERS_DATA_KEY,
    TRENDING_KEYWORDS_WIDGET_DATA_KEY,
    IMPACT_SCORE_WIDGET_CHART_DATA_KEY,
    IMPACT_SCORE_WIDGET_PREVIOUS_DATA_KEY,
    DEMOGRAPHICS_WIDGET_COUNTRIES_DATA_KEY,
    DEMOGRAPHICS_WIDGET_LANGUAGES_DATA_KEY,
    TRENDING_KEYWORDS_WIDGET_PREVIOUS_DATA_KEY,
    NETWORK_BREAKDOWN_WIDGET_CHART_DATA_KEY
];
